import { devtools } from 'zustand/middleware';
import create, { StateCreator } from 'zustand';

export const StoreWithDevtools = <T extends unknown>(state: StateCreator<T,[["zustand/devtools", never]],[],T>) =>
  create(devtools(state));
